import type { TranslationKey } from "./en";

// Kiswahili. Machine-drafted for the console — have a native speaker on the
// ops team review before relying on it for anything customer-facing.
export const sw: Record<TranslationKey, string> = {
  "app.name": "Smart Safiri",
  "app.console": "Kituo cha Uendeshaji",
  "shell.changePassword": "Badilisha nenosiri",
  "shell.logout": "Toka",
  "shell.language": "Lugha",
  "shell.administrator": "Msimamizi",

  "nav.section.Operations": "Uendeshaji",
  "nav.section.Finance": "Fedha",
  "nav.section.Support": "Huduma kwa Wateja",
  "nav.section.System": "Mfumo",

  "nav.dashboard": "Muhtasari wa zamani",
  "nav.drivers": "Madereva",
  "nav.referrals": "Rufaa na mawakala",
  "nav.trips": "Safari",
  "nav.users": "Abiria",
  "nav.ride-types": "Aina za Safari na Bei",
  "nav.toll-locations": "Vituo vya Ushuru",
  "nav.tags": "Lebo",
  "nav.coupons": "Misimbo ya Punguzo",
  "nav.transactions": "Miamala",
  "nav.settlements": "Malipo ya Mkono",
  "nav.payouts": "Malipo kwa Madereva",
  "nav.payout-catalogue": "Njia za Kupokea Malipo",
  "nav.tax-receipts": "Risiti za Kodi",
  "nav.latra": "LATRA ya Mwezi",
  "nav.reports": "Ripoti",
  "nav.sos": "Tahadhari za SOS",
  "nav.queries": "Maswali ya Wateja",
  "nav.lost-items": "Vitu Vilivyopotea",
  "nav.admins": "Wasimamizi",
  "nav.audit": "Kumbukumbu za Ukaguzi",
  "nav.settings": "Mipangilio",

  "common.all": "Zote",
  "common.search": "Tafuta",
  "common.refresh": "Onyesha upya",
  "common.date": "Tarehe",
  "common.status": "Hali",
  "common.none": "—",
  "common.lastDays": "Siku {n} zilizopita",

  "audit.title": "Kumbukumbu za Ukaguzi",
  "audit.subtitle": "Kila badiliko lililofanywa kwenye kituo — nani, nini na lini",
  "audit.tab.activity": "Shughuli",
  "audit.tab.access": "Ukaguzi wa ruhusa",
  "audit.search": "Tafuta njia, msimamizi au kitendo",
  "audit.writesOnly": "Mabadiliko pekee",
  "audit.col.when": "Lini",
  "audit.col.admin": "Msimamizi",
  "audit.col.action": "Kitendo",
  "audit.col.result": "Matokeo",
  "audit.empty": "Hakuna shughuli iliyorekodiwa bado",
  "audit.outcome.allowed": "Imeruhusiwa",
  "audit.outcome.denied": "Imezuiwa",
  "audit.outcome.would_deny": "Ingezuiwa",
  "audit.detail.title": "Kumbukumbu ya ukaguzi",
  "audit.detail.request": "Ombi",
  "audit.detail.admin": "Msimamizi",
  "audit.detail.payload": "Taarifa zilizotumwa",
  "audit.detail.change": "Badiliko",
  "audit.detail.permission": "Ruhusa",
  "audit.detail.duration": "Muda",
  "audit.access.mode": "Ukaguzi wa majukumu kwenye seva",
  "audit.access.mode.off": "Umezimwa",
  "audit.access.mode.log": "Kurekodi tu",
  "audit.access.mode.enforce": "Unatekelezwa",
  "audit.access.mode.logHelp":
    "Maombi ambayo jukumu halipaswi kufanya yanarekodiwa hapa chini lakini bado yanaruhusiwa. Orodha hii ikibaki tupu wakati wa matumizi ya kawaida, utekelezaji unaweza kuwashwa.",
  "audit.access.mode.enforceHelp":
    "Maombi yaliyo nje ya ruhusa za jukumu yanakataliwa na API.",
  "audit.access.clean": "Hakuna maombi yaliyokataliwa katika kipindi hiki.",
  "audit.access.refusals": "Maombi yaliyokataliwa",
  "audit.access.matrix": "Ruhusa za majukumu",
  "audit.access.count": "Idadi",
  "audit.access.lastSeen": "Mara ya mwisho",
  "audit.access.role": "Jukumu",

  // ---- Operations console ----
  "shell.skipToContent": "Ruka hadi maudhui",
  "shell.menu": "Menyu kuu",
  "shell.account": "Menyu ya akaunti",
  "nav.section.Command": "Amri",
  "nav.section.Insights": "Uchambuzi",
  "nav.section.Compliance": "Uzingatiaji",
  "nav.section.Configuration": "Usanidi",
  "nav.home": "Nyumbani",
  "nav.live": "Uendeshaji wa moja kwa moja",
  "nav.inbox": "Kazi zinazosubiri",
  "nav.finance": "Muhtasari wa fedha",
  "nav.analytics": "Takwimu",
  "nav.monthly": "Muhtasari wa mwezi",
  "common.close": "Funga",
  "common.noData": "Hakuna data kwa kipindi hiki",
  "common.updated": "Imesasishwa {time}",
  "common.vsPrevious": "ukilinganisha na kipindi kilichopita",
  "window.period": "Kipindi",
  "window.range": "Tarehe",
  "window.groupBy": "Panga kwa",
  "window.auto": "Otomatiki",
  "window.day": "Siku",
  "window.week": "Wiki",
  "window.month": "Mwezi",
  "window.today": "Leo",
  "window.7d": "Siku 7 zilizopita",
  "window.30d": "Siku 30 zilizopita",
  "window.90d": "Siku 90 zilizopita",
  "window.thisMonth": "Mwezi huu",
  "window.lastMonth": "Mwezi uliopita",
  "window.thisYear": "Mwaka huu",
  "window.custom": "Tarehe maalum",
  "search.placeholder": "Tafuta moduli, vitendo, safari, madereva…",
  "search.empty": "Hakuna kinacholingana — jaribu namba ya safari, simu au namba ya gari",
  "search.group.recent": "Za karibuni",
  "search.group.actions": "Vitendo",
  "search.group.modules": "Nenda kwa",
  "search.group.trips": "Safari",
  "search.group.drivers": "Madereva",
  "search.group.riders": "Abiria",
  "search.hint.navigate": "kusogea",
  "search.hint.open": "kufungua",
  "search.action.onboardDriver": "Sajili dereva mpya",
  "search.action.reviewDrivers": "Kagua madereva wanaosubiri idhini",
  "search.action.stuckTrips": "Onyesha safari zilizokwama",
  "search.action.demandMap": "Madereva wanahitajika wapi? (ramani ya mahitaji)",
  "search.action.reassign": "Ghairi, hamisha au kamilisha safari",
  "search.action.activeSos": "Fungua tahadhari za SOS",
  "search.action.recordSettlement": "Rekodi malipo ya taslimu",
  "search.action.cashReconciliation": "Ulinganisho wa taslimu — nani anadaiwa kamisheni",
  "search.action.createPromo": "Tengeneza msimbo wa punguzo",
  "search.action.driverLeaderboard": "Alama za madereva",
  "search.action.monthlySummary": "Muhtasari wa mwezi (chapisha / PDF)",
  "search.action.addAdmin": "Ongeza msimamizi",
  "search.action.accessReview": "Ukaguzi wa ruhusa za majukumu",
  "search.action.changePassword": "Badilisha nenosiri langu",
  "search.action.toggleTheme": "Badili hali ya giza",
  "search.action.switchLanguage": "Badili lugha",
  "search.action.darkMode": "Tumia hali ya giza",
  "search.action.lightMode": "Tumia hali ya mwanga",
  "search.action.useSwahili": "Badili lugha: Kiswahili",
  "search.action.useEnglish": "Switch language: English",
  "home.morning": "Habari za asubuhi",
  "home.afternoon": "Habari za mchana",
  "home.evening": "Habari za jioni",
  "home.openLive": "Fungua ubao wa moja kwa moja",
  "home.find": "Tafuta chochote",
  "home.vsYesterday": "ukilinganisha na muda huu jana",
  "home.kpi.requests": "Maombi ya safari leo",
  "home.kpi.completed": "Zilizokamilika",
  "home.kpi.fulfilment": "Kiwango cha kuhudumiwa",
  "home.kpi.fulfilmentHint": "Zilizokamilika ÷ maombi yaliyomalizika (yaliyokamilika, kughairiwa au kukosa dereva).",
  "home.kpi.timeToAccept": "Wastani wa muda wa kukubaliwa",
  "home.kpi.riderPayments": "Malipo ya abiria",
  "home.kpi.safiriEarned": "Mapato ya Smart Safiri",
  "home.needsAttention": "Inahitaji uangalizi",
  "home.rightNow": "Barabarani sasa hivi",
  "home.supplyLine": "{idle} wazi · {busy} kazini · {waiting} wanasubiri",
  "home.last14": "Siku 14 zilizopita",
  "inbox.title": "Kazi zinazosubiri",
  "inbox.subtitle": "Kila kitu kinachosubiri mtu, cha dharura kwanza",
  "inbox.viewAll": "Tazama zote",
  "inbox.allClear": "Kila kitu kiko sawa — hakuna kinachohitaji uangalizi sasa.",
  "inbox.section.sos": "Tahadhari za SOS zilizo hai",
  "inbox.section.stuckTrips": "Safari zilizokwama",
  "inbox.section.driverApprovals": "Madereva wanaosubiri idhini",
  "inbox.section.docExpiry": "Nyaraka zinazoisha ndani ya siku 30",
  "inbox.section.lowRated": "Madereva wenye alama za chini (chini ya 4.0)",
  "inbox.section.debt": "Madereva waliozidi kikomo cha deni",
  "inbox.section.payouts": "Malipo kwa madereva yaliyoshindwa au kukwama",
  "inbox.section.compliance": "Hitilafu za LATRA na risiti za kodi",
  "inbox.section.queries": "Maswali ya wateja yaliyo wazi (ya zamani kwanza)",
  "inbox.section.lostItems": "Kesi za vitu vilivyopotea zilizo wazi",
  "inbox.section.partWalletUnconfirmed": "Safari za mkoba + taslimu ambazo taslimu haijathibitishwa",
  "live.title": "Uendeshaji wa moja kwa moja",
  "live.subtitle": "Kila dereva na safari inayoendelea sasa hivi",
  "live.autoRefresh": "Onyesha upya kiotomatiki",
  "live.sosBanner": "Tahadhari {n} za SOS zilizo hai",
  "live.filter.all": "Zote",
  "live.filter.searching": "Inatafuta",
  "live.filter.toPickup": "Kuelekea kuchukua",
  "live.filter.atPickup": "Mahali pa kuchukua",
  "live.filter.onTrip": "Safarini",
  "live.filter.atDestination": "Mwisho wa safari",
  "live.filter.stuck": "Zimekwama",
  "live.layer": "Tabaka la ramani",
  "live.layer.vehicles": "Magari",
  "live.layer.demand": "Mahitaji dhidi ya madereva",
  "live.demandWindow": "Kipindi cha mahitaji",
  "live.window.30m": "Dakika 30 zilizopita",
  "live.window.1h": "Saa 1 iliyopita",
  "live.window.3h": "Saa 3 zilizopita",
  "live.window.24h": "Saa 24 zilizopita",
  "live.window.7d": "Siku 7 zilizopita",
  "live.rideType": "Aina ya safari",
  "live.allRideTypes": "Aina zote",
  "live.idle": "Wazi",
  "live.assigned": "Amepangiwa",
  "live.busy": "Kazini",
  "live.stale": "Hakuna ishara",
  "live.searching": "Inatafuta",
  "live.stuck": "Imekwama",
  "live.onTrip": "Barabarani",
  "live.idleDrivers": "Madereva walio wazi",
  "live.noMapKey": "Ramani inahitaji ufunguo wa Google Maps (VITE_GOOGLE_MAPS_API_KEY). Mengine yote kwenye ubao huu yanafanya kazi bila huo.",
  "live.mapError": "Ramani imeshindwa kupakia. Kagua ufunguo wa Google Maps.",
  "live.selected": "Iliyochaguliwa",
  "live.openTrip": "Fungua safari",
  "live.tab.trips": "Safari",
  "live.tab.drivers": "Madereva",
  "live.tab.demand": "Maeneo yenye mahitaji",
  "live.noTrips": "Hakuna safari inayolingana.",
  "live.noDriver": "Bado hakuna dereva",
  "live.findDriver": "Tafuta dereva, namba ya gari au simu",
  "live.demandHelp": "Maeneo yamepangwa kwa maombi (na maombi yaliyokosa dereva) kwa kila dereva aliye wazi. Tuma madereva juu ya orodha hii.",
  "live.showDemand": "Onyesha mahitaji kwenye ramani",
  "live.showHeatmap": "Ramani ya joto ya mahitaji",
  "live.noDemand": "Hakuna maombi katika kipindi hiki.",
  "live.cell.title": "Eneo hili",
  "live.cell.requests": "Maombi {n}",
  "live.cell.unserved": "{n} yamekosa dereva",
  "live.cell.idle": "Madereva {n} wako wazi sasa",
  "live.cell.line": "maombi {r} · {u} bila dereva · {d} wazi",
  "live.rider": "Abiria",
  "live.driver": "Dereva",
  "live.inStatus": "{m} katika hali hii",
  "live.lockedForDebt": "imefungwa kwa deni",
  "live.lastSeen": "Alionekana mwisho {time}",
  "actions.callDriver": "Mpigie dereva",
  "actions.callRider": "Mpigie abiria",
  "actions.driver": "Dereva",
  "actions.rider": "Abiria",
  "actions.intervene": "Chukua hatua",
  "actions.reassign": "Hamisha dereva",
  "actions.forceComplete": "Kamilisha na lipa",
  "actions.cancelTrip": "Ghairi safari",
  "actions.fault": "Kosa ni la nani?",
  "actions.faultHelp": "Inarekodiwa kwenye safari na kutumika kwenye takwimu za kughairi.",
  "actions.fault.platform": "Hakuna — sababu ya kiutendaji (tukio, marudio, majaribio)",
  "actions.fault.rider": "Abiria",
  "actions.fault.driver": "Dereva",
  "actions.newDriver": "Dereva mpya",
  "actions.autoDispatch": "Tuma upya kiotomatiki kwa madereva walio karibu",
  "actions.noIdleDrivers": "Hakuna madereva wa aina hii walio wazi karibu — tumia kutuma upya kiotomatiki.",
  "actions.reason": "Sababu",
  "actions.reasonHelp": "Inahifadhiwa kwenye kumbukumbu za ukaguzi pamoja na jina lako.",
  "actions.back": "Rudi",
  "actions.confirm.cancel": "Ghairi safari hii",
  "actions.confirm.reassign": "Hamisha",
  "actions.confirm.complete": "Kamilisha na lipa",
  "actions.explain.cancel": "Abiria na dereva wanajulishwa na dereva anaachiliwa kwa safari mpya. Hakuna anayetozwa.",
  "actions.explain.reassign": "Dereva wa sasa anaondolewa kwenye safari na kujulishwa. Mpigie pia — matoleo ya zamani ya programu yanaweza yasionyeshe badiliko mara moja.",
  "actions.explain.complete": "Inalipa safari kama vile dereva angebonyeza “taslimu imepokelewa” (au malipo ya pochi): malipo, kamisheni, salio la dereva, LATRA na risiti ya kodi vyote vinaendelea kawaida. Fanya hivi tu baada ya kuthibitisha abiria amelipa.",
  "actions.done.cancel": "Safari imeghairiwa",
  "actions.done.complete": "Safari imekamilika na kulipwa",
  "actions.done.assigned": "Dereva mpya amepewa safari",
  "actions.done.searching": "Tunatafuta dereva mpya",
  "actions.closeUnpaid": "Funga kama haijalipwa",
  "actions.refundWallet": "Rejesha sehemu ya mkoba",
  "actions.confirm.closeUnpaid": "Funga safari kama haijalipwa",
  "actions.confirm.refundWallet": "Rejesha kwenye mkoba wa abiria",
  "actions.explain.closeUnpaid": "Tumia pale abiria hakulipa taslimu, au safari inaghairiwa baada ya kufika. Safari inakamilika, dereva bado anapata mapato yake yote, na Smart Safiri inabeba kiasi ambacho abiria hakulipa.",
  "actions.explain.refundWallet": "Inarejesha sehemu ya mkoba ya safari hii iliyokamilika kwa abiria kama “Marejesho ya safari”. Mapato ya dereva hayabadiliki; Smart Safiri inabeba marejesho.",
  "actions.partSplit": "Mkoba {wallet} (tayari imechukuliwa) · taslimu {cash}",
  "actions.keepWallet": "Baki na sehemu ya mkoba kulipia nauli",
  "actions.keepWalletHelp": "Imezimwa (chaguo-msingi): sehemu ya mkoba inarudi kwa abiria.",
  "actions.done.closeUnpaid": "Safari imefungwa kama haijalipwa",
  "actions.done.refundWallet": "Sehemu ya mkoba imerejeshwa kwa abiria",
  "fin.title": "Muhtasari wa fedha",
  "fin.subtitle": "Abiria walilipa nini, Smart Safiri ilibaki na nini, na nani anadaiwa na nani",
  "fin.comparedWith": "Ikilinganishwa na {from} – {to}",
  "fin.riderPaid": "Malipo ya abiria",
  "fin.riderPaidHint": "Kiasi abiria walicholipa kwa safari zilizokamilika (baada ya punguzo, pamoja na ushuru na ada za malipo).",
  "fin.safiriEarned": "Mapato ya Smart Safiri",
  "fin.safiriEarnedHint": "Kamisheni + ada za kuweka nafasi − punguzo − VAT ya ada za kuweka nafasi.",
  "fin.takeRate": "Asilimia ya Smart Safiri",
  "fin.takeRateHint": "Mapato ya Smart Safiri ÷ malipo ya abiria.",
  "fin.trips": "Safari",
  "fin.avgFare": "Wastani wa nauli",
  "fin.discounts": "Punguzo lililotolewa",
  "fin.discountsHint": "Punguzo la misimbo lililolipwa na Smart Safiri.",
  "fin.tab.overview": "Muhtasari",
  "fin.tab.breakdown": "Kwa njia ya malipo na aina ya safari",
  "fin.tab.cash": "Taslimu na salio",
  "fin.tab.cashback": "Pesa rejeshwa",
  "cb.view.report": "Zilizolipwa",
  "cb.view.pairs": "Jozi zinazojirudia",
  "cb.view.settings": "Mipangilio",
  "cb.netCost": "Gharama ya pesa rejeshwa",
  "cb.netCostHint": "Pesa rejeshwa zilizotolewa katika kipindi, ukiondoa zilizorudishwa. Zilizofutwa zinabaki kuwa gharama.",
  "cb.toPassengers": "Kwa abiria",
  "cb.toDrivers": "Kwa madereva",
  "cb.toDriversHint": "{amount} kati yake zililipa kamisheni waliyodaiwa madereva.",
  "cb.shareOfEarnings": "Sehemu ya mapato ya Smart Safiri",
  "cb.shareOfEarningsHint": "Gharama ya pesa rejeshwa kama sehemu ya mapato ya Smart Safiri kwenye safari hizo hizo.",
  "cb.shareShort": "Ya mapato",
  "cb.rides": "Safari",
  "cb.writtenOff": "Zilizofutwa",
  "cb.writtenOffHint": "Pesa rejeshwa za abiria zilizokuwa zimetumika wakati wa kuondolewa. Safari {n} zimeondolewa.",
  "cb.overTime": "Pesa rejeshwa kwa muda",
  "cb.passenger": "Abiria",
  "cb.driver": "Dereva",
  "cb.records": "Pesa rejeshwa kwa safari",
  "cb.all": "Zote",
  "cb.grantedBadge": "Imetolewa",
  "cb.reversed": "Imeondolewa",
  "cb.granted": "Ilitolewa",
  "cb.trip": "Abiria → dereva",
  "cb.rideType": "Aina ya safari",
  "cb.fareBase": "Nauli",
  "cb.offsetShort": "{amount} zililipa kamisheni",
  "cb.writtenOffShort": "{amount} zimefutwa",
  "cb.reverse": "Ondoa",
  "cb.noRecords": "Hakuna pesa rejeshwa katika kipindi hiki",
  "cb.reverseTitle": "Ondoa pesa rejeshwa",
  "cb.reverseBody": "Hii itarudisha {passenger} kutoka kwa abiria na {driver} kutoka kwa dereva.",
  "cb.reverseRules": "Kama abiria ameshatumia, salio lililobaki tu litachukuliwa na kilichobaki kitafutwa. Mkoba wa dereva unaweza kuwa hasi; akizidi kikomo cha deni hatapokea safari mpya.",
  "cb.reason": "Sababu (itahifadhiwa)",
  "cb.cancel": "Ghairi",
  "cb.reversedOk": "Pesa rejeshwa zimeondolewa",
  "cb.reversedWithWriteOff": "Pesa rejeshwa zimeondolewa. {amount} zilikuwa zimetumika na zimefutwa.",
  "cb.pairsTitle": "Jozi za abiria na dereva zinazojirudia",
  "cb.pairsHelp": "Jozi zenye safari fupi nyingi pamoja katika kipindi hiki. Zikague mwenyewe; hakuna kinachowekwa alama moja kwa moja.",
  "cb.pairsNext": "Kuchukua hatua kwa safari ya udanganyifu, ifungue na uondoe pesa rejeshwa zake.",
  "cb.minRides": "Angalau (safari)",
  "cb.maxKm": "Safari hadi",
  "cb.distance": "Umbali",
  "cb.cashbackPaid": "Pesa rejeshwa",
  "cb.grantedOn": "kwa safari {n}",
  "cb.period": "Safari ya kwanza / mwisho",
  "cb.noPairs": "Hakuna jozi zinazozidi kiwango",
  "cb.settings": "Mipangilio ya pesa rejeshwa",
  "cb.lastChanged": "Ilibadilishwa mwisho {at} na {by}",
  "cb.programOn": "Mpango umewashwa",
  "cb.programOff": "Mpango umezimwa",
  "cb.switchHelp": "Safari zinazokamilika ukiwa umewashwa tu ndizo hupata pesa rejeshwa. Kuuwasha hakulipii safari za awali; kuuzima hakuondoi zilizotolewa.",
  "cb.passengerRate": "Kiwango cha abiria",
  "cb.driverRate": "Kiwango cha dereva",
  "cb.overrides": "Viwango maalum kwa aina ya safari",
  "cb.overridesHelp": "Acha kiwango wazi kutumia cha kawaida. Mabadiliko yanahusu safari mpya tu.",
  "cb.pickRideType": "Chagua aina ya safari",
  "cb.useDefault": "Kawaida",
  "cb.removeOverride": "Ondoa kiwango maalum",
  "cb.addOverride": "Ongeza kiwango maalum",
  "cb.changeNote": "Maelezo ya mabadiliko",
  "cb.changeNotePlaceholder": "Kwa nini unabadilisha?",
  "cb.save": "Hifadhi mipangilio",
  "cb.settingsSaved": "Mipangilio ya pesa rejeshwa imehifadhiwa",
  "cb.readOnly": "CEO na timu ya Fedha (finance.manage) tu ndio wanaweza kubadilisha mipangilio hii.",
  "cb.history": "Kumbukumbu ya mabadiliko",
  "cb.when": "Lini",
  "cb.by": "Na",
  "cb.program": "Mpango",
  "cb.rates": "Abiria / dereva",
  "cb.note": "Maelezo",
  "cb.on": "Umewashwa",
  "cb.off": "Umezimwa",
  "cb.noHistory": "Haijawahi kubadilishwa: mpango umezimwa kwa viwango vya kuanzia.",
  "fin.overTime": "Kwa muda",
  "fin.whereMoneyWent": "Pesa zilienda wapi",
  "fin.amount": "Kiasi",
  "fin.toDriver": "Mapato ya madereva",
  "fin.toGateway": "Ada za malipo ya mtandao",
  "fin.toLatra": "Tozo ya LATRA (inapelekwa LATRA)",
  "fin.latraLevyRow": "Tozo ya LATRA",
  "fin.baseFareRow": "Nauli ya msingi",
  "fin.distanceRow": "Umbali",
  "fin.timeRow": "Muda",
  "fin.waitingTimeRow": "Muda wa kusubiri",
  "fin.rounding": "Ukadiriaji",
  "fin.inclTolls": "pamoja na ushuru {v} uliopelekwa kwa madereva",
  "fin.fareRow": "Nauli",
  "fin.roundingRow": "Ukadiriaji (hadi 500 iliyo karibu)",
  "fin.waitingFeeRow": "ambayo ni muda wa kusubiri",
  "fin.cancellationFeeRow": "Ada ya kughairi ya awali",
  "fin.toCancelledTrip": "Ada ya kughairi (imelipwa kwenye safari iliyoghairiwa)",
  "fin.tollsRow": "Ushuru",
  "fin.gatewayFeeRow": "Ada ya malipo ya mtandao",
  "fin.bookingFeeRow": "Ada ya kuweka nafasi",
  "fin.discountRow": "Punguzo",
  "fin.commissionRow": "Kamisheni",
  "fin.vatOnCommissionRow": "VAT ya kamisheni",
  "fin.vatOnBookingFeeRow": "VAT ya ada ya kuweka nafasi",
  "fin.waterfallLabel": "Kati ya {paid} walizolipa abiria, Smart Safiri ilibaki na {kept}.",
  "fin.byRail": "Pesa kwa njia: mkoba {wallet} · taslimu {cash} · mtandaoni {online}. Safari {n} zilizolipwa sehemu mkoba, sehemu taslimu zinahesabiwa pande zote mbili.",
  "fin.byPaymentMethod": "Kwa njia ya malipo",
  "fin.byRideType": "Kwa aina ya safari",
  "fin.receivables": "Madereva wanadaiwa na Smart Safiri",
  "fin.receivablesHint": "Kamisheni ambayo madereva bado wanadaiwa, hasa kutoka safari za taslimu.",
  "fin.payables": "Smart Safiri inadaiwa na madereva",
  "fin.payablesHint": "Salio la pochi za madereva linaloweza kutolewa.",
  "fin.payoutsInFlight": "Malipo yanayoendelea",
  "fin.riderWallets": "Salio la pochi za abiria",
  "fin.riderWalletsHint": "Pesa abiria walizoweka lakini bado hawajatumia.",
  "fin.driversCount": "Madereva {n}",
  "fin.countItems": "Malipo {n}",
  "fin.lockedDrivers": "Madereva {n} wamezuiwa kupokea safari mpya hadi walipe salio lao.",
  "fin.commissionStatus": "Ukusanyaji wa kamisheni",
  "fin.commissionStatusHelp": "Kamisheni ya safari zilizokamilika katika kipindi hiki, na kama imekusanywa.",
  "fin.status": "Hali",
  "fin.paymentMethod": "Njia ya malipo",
  "fin.oldestUncollected": "Kamisheni ya zamani ambayo haijakusanywa",
  "fin.oldestUncollectedHelp": "Madereva waliodaiwa kwa muda mrefu zaidi. Nyekundu = zaidi ya siku 7.",
  "fin.since": "Anadaiwa tangu",
  "fin.nothingOwed": "Hakuna deni.",
  "an.title": "Takwimu",
  "an.subtitle": "Ubora wa huduma, madereva na abiria kwa muda",
  "an.tab.operations": "Uendeshaji",
  "an.tab.drivers": "Madereva",
  "an.tab.riders": "Abiria",
  "an.requests": "Maombi",
  "an.unserved": "Hakuna dereva",
  "an.unservedHint": "Sehemu ya maombi ambayo hakuna dereva aliyekubali — mahitaji yaliyopotea.",
  "an.cancelRate": "Kiwango cha kughairi",
  "an.cancelSplit": "{r} na abiria · {d} na madereva",
  "an.pickupTime": "Wastani wa muda wa kufika",
  "an.promisedEta": "Muda ulioahidiwa {m}",
  "an.outcomesOverTime": "Matokeo ya maombi",
  "an.completed": "Zilizokamilika",
  "an.cancelled": "Zilizoghairiwa",
  "an.noDriver": "Hakuna dereva",
  "an.speedOverTime": "Kasi ya huduma",
  "an.toAccept": "Hadi kukubaliwa",
  "an.toArrive": "Hadi kufika",
  "an.onTrip": "Safarini",
  "an.whenDemand": "Abiria wanataka safari lini",
  "an.whenDemandHelp": "Maombi kwa siku na saa (saa za Afrika Mashariki). Pembe nyekundu zinaonyesha saa ambazo abiria walikosa dereva — panga madereva hapo.",
  "an.heatmapLabel": "Maombi ya safari kwa siku ya wiki na saa",
  "an.heatCell": "{day} {hour}: maombi {n}, {u} bila dereva",
  "an.fewer": "Machache",
  "an.more": "Mengi",
  "an.hadUnserved": "Baadhi ya maombi hayakuhudumiwa",
  "an.dow.1": "Jtt",
  "an.dow.2": "Jnn",
  "an.dow.3": "Jtn",
  "an.dow.4": "Alh",
  "an.dow.5": "Iju",
  "an.dow.6": "Jmm",
  "an.dow.7": "Jpi",
  "an.topPickups": "Maeneo yenye maombi mengi",
  "an.place": "Mahali",
  "an.cancelReasons": "Kwa nini safari zilighairiwa",
  "an.cancelledBy": "Na",
  "an.reason": "Sababu",
  "an.count": "Idadi",
  "an.byRideType": "Kwa aina ya safari",
  "an.approvedDrivers": "Madereva walioidhinishwa",
  "an.activeDrivers": "Madereva hai",
  "an.activeDriversHint": "Madereva waliokamilisha angalau safari moja katika kipindi.",
  "an.onlineNow": "Mtandaoni sasa",
  "an.tripsPerDriver": "Safari kwa kila dereva hai",
  "an.acceptance": "Kiwango cha kukubali",
  "an.utilisation": "Matumizi ya muda",
  "an.utilisationHint": "Takriban sehemu ya muda wa mtandaoni uliotumika safarini (kutoka kuwasha/kuzima).",
  "an.scorecards": "Alama za madereva",
  "an.sortBy": "Panga madereva kwa",
  "an.sort.earnings": "Mapato ya juu",
  "an.sort.completed": "Safari nyingi",
  "an.sort.acceptance": "Kukubali kwa chini",
  "an.sort.cancellations": "Kughairi kwingi",
  "an.sort.rating": "Alama za chini",
  "an.offers": "Maombi",
  "an.driverCancels": "Aliyoghairi",
  "an.rating": "Alama",
  "an.earnings": "Mapato",
  "an.owes": "Anadaiwa",
  "an.showingTop": "Inaonyesha madereva {n} kati ya {total} — pakua kwa orodha kamili.",
  "an.totalRiders": "Abiria waliosajiliwa",
  "an.everRode": "{n} wamewahi kusafiri",
  "an.activeRiders": "Abiria hai",
  "an.activeRidersHint": "Abiria wenye angalau safari moja iliyokamilika katika kipindi.",
  "an.repeatRate": "Abiria wanaorudi",
  "an.repeatRateHint": "Abiria hai waliosafiri mara 2 au zaidi katika kipindi.",
  "an.tripsPerRider": "Safari kwa kila abiria",
  "an.spendPerRider": "Matumizi kwa kila abiria",
  "an.newRiders": "Abiria wapya",
  "an.newRidersHint": "Abiria ambao safari yao ya kwanza ilikamilika katika kipindi hiki.",
  "an.growth": "Usajili dhidi ya safari za kwanza",
  "an.signups": "Usajili",
  "an.firstRides": "Safari za kwanza",
  "an.cohorts": "Abiria wanaorudi kwa mwezi wa kwanza",
  "an.cohortsHelp": "Kati ya abiria ambao safari yao ya kwanza ilikuwa mwezi fulani (M0), sehemu waliosafiri tena miezi 1, 2, 3… baadaye.",
  "an.cohort": "Mwezi wa kwanza",
  "an.riders": "Abiria",
  "monthly.title": "Muhtasari wa mwezi — {month}",
  "monthly.subtitle": "Imetolewa {generated} · ikilinganishwa na mwezi uliopita",
  "monthly.month": "Mwezi",
  "monthly.print": "Chapisha / hifadhi kama PDF",
  "monthly.headlines": "Mambo makuu",
  "monthly.vsLastMonth": "ukilinganisha na mwezi uliopita",
  "monthly.h.trips": "Safari {n} zilikamilika{c}.",
  "monthly.h.money": "Abiria walilipa {paid}; Smart Safiri ilibaki na {kept}{c}, asilimia {rate}.",
  "monthly.h.fulfilment": "{rate} ya maombi yaliyomalizika yalihudumiwa; maombi {unserved} yalikosa dereva.",
  "monthly.h.pickup": "Madereva walichukua wastani wa {m} kumfikia abiria.",
  "monthly.h.receivables": "Madereva kwa sasa wanadaiwa {v} na Smart Safiri (madereva {n}).",
  "monthly.topDrivers": "Madereva bora kwa mapato",
  "monthly.unservedN": "{n} bila dereva",
  "fin.short.paid": "Abiria alilipa",
  "fin.short.driver": "Dereva",
  "fin.short.vatCommission": "VAT (dereva)",
  "fin.short.vatBooking": "VAT (ada)",
  "fin.short.cancellationFee": "Ada ya kughairi",
  "fin.short.gateway": "Mtandao",
  "fin.short.latra": "LATRA",
  "fin.short.rounding": "Ukadiriaji",
  "fin.short.safiri": "Smart Safiri",
};
